import Vue from 'vue'
import Router from 'vue-router'
import { Notification } from 'element-ui';
Vue.use(Router);

const routerPush = Router.prototype.push
// 修复路由重复点击报错
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}

// 动态导入路由
let routes = [];
const blackList = ['./index.js']  // 不导入的js文件

// 获取路由文件上下文
const files = require.context('.', true, /\.js$/)
// 拼接路由列表
files.keys().forEach(key => {
  if (blackList.indexOf(key) > -1) return
  routes = routes.concat(files(key).default.routes)
})



const router = new Router({
  mode:'history',
  routes
  // { path: '*', component: '@/project/views/Welcome.vue' }

});


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js